// The names of the aroma icons, kept apart from the heavy drawings so a screen can know them
// without loading the sprite. A family icon is named by its lexicon cluster id; a descriptor icon
// by the word the board draws (`cherry` for `red-fruit.red-cherry`; the mapping is lib/aromaStyle).

export const FAMILY_ICON_IDS = [
  "floral",
  "green-fruit",
  "citrus",
  "stone-fruit",
  "tropical-fruit",
  "red-fruit",
  "black-fruit",
  "herbaceous",
  "herbal",
  "spice-fresh",
  "mineral",
  "yeast",
  "malolactic",
  "oak",
  "oxidative",
  "fruit-development",
  "bottle-age",
] as const;

export const DESCRIPTOR_ICON_IDS = [
  "cherry",
  "raspberry",
  "redcurrant",
  "cranberry",
  "plum",
  "vanilla",
  "cedar",
  "coconut",
  "toast",
  "smoke",
  "clove",
  "cinnamon",
  "charred",
  "tobacco",
  "honey",
] as const;

export type FamilyIconId = (typeof FAMILY_ICON_IDS)[number];
export type DescriptorIconId = (typeof DESCRIPTOR_ICON_IDS)[number];
export type AromaIconId = FamilyIconId | DescriptorIconId;

/** Every icon the sprite draws: the 17 families, then the 15 descriptors. */
export const AROMA_ICON_IDS: readonly AromaIconId[] = [...FAMILY_ICON_IDS, ...DESCRIPTOR_ICON_IDS];

/** The id of an icon's `<symbol>` in the sprite; the prefix keeps it clear of every other id on the page. */
export function aromaSymbolId(id: AromaIconId): string {
  return `aroma-${id}`;
}
